export default "<p>signage-card works!</p>\r\n"